import React, { useEffect, useState } from "react";
import "./search.css";
import classNames from "classnames";
import { Link } from "react-router-dom";
import axios from "axios";

export default function Search() {
  // 选项栏是否展示
  const [open, setOpen] = useState(false);
  // 选项栏中展示的内容
  const [webpage, setWebpage] = useState("百度");
  const [webimg, setWebimg] = useState(
    "http://mv.venlou.com/Public/image/searchIco/bd.png"
  );
  const [weburl, setWeburl] = useState(
    "https://www.baidu.com/s?ie=UTF-8&tn=02003390_42_hao_pg&wd"
  );
  // 新闻栏是否展示
  const [newslist, setNewslist] = useState(false);

  useEffect(() => {}, [open]);
  // 决定组件是否固定定位
  const [hight, setHight] = useState(false);

  // 判断组件高度
  useEffect(() => {
    const fixedTo = document.getElementById("a_id").offsetTop;
    window.onscroll = () => {
      let scrollTo = Math.max(
        document.body.scrollTop,
        document.documentElement.scrollTop
      );
      if (scrollTo > fixedTo) {
        setHight(true);
      } else if (scrollTo <= fixedTo) {
        setHight(false);
      }
    };
  }, [hight]);

  // 鼠标移入移出事件
  const [enter, setEnter] = useState(false);

  // 切换的默认数据
  const [huan, setHuan] = useState(1);

  // 获取文字新闻
  const [newtitle, setNewtitle] = useState([]);
  const [newlist, setNewlist] = useState([]);
  const [huanlists, setHuanlists] = useState([]);
  useEffect(() => {
    axios.get("http://www.itemev.com/home/Search").then((response) => {
      setNewtitle(response.data.slice(0, 6));
      setNewlist(response.data.slice(0, 18));
      setHuanlists(response.data.slice(19, 22));
    });
  }, []);

  // 切换数据的长度
  const len = huanlists.length;

  const [content, setContent] = useState("");

  const [biying, setBiying] = useState([]);
  useEffect(() => {
    axios.get("http://mv.venlou.com/SearchSite").then((response) => {
      setBiying(response.data);
    });
  }, []);

  return (
    <div>
      <div
        className={classNames("search", {
          "search-position": hight === true,
          "search-positions": hight === false,
        })}
        id="a_id"
      >
        {/* 百度LOGO */}
        <div className="baiduLogo">
          <Link to="https://www.baidu.com/">
            <img
              src={require("./img/baiduLogo.png")}
              alt=""
              className="baiduSize"
            />
          </Link>
        </div>
        {/* 中间部分 */}
        <div className="center">
          {/* 搜索框 */}
          <div
            className={classNames("center-input", {
              "center-inputs": open === true,
            })}
          >
            {/* 网页 */}
            <div
              className="webpage"
              onClick={() => {
                setOpen(!open);
              }}
            >
              <img src={webimg} alt="" className="first-img" />
              <span>{webpage}</span>
              {/* 修改状态展开选项 */}
              {open === false && (
                <img
                  src={require("./img/webpage.png")}
                  alt=""
                  className="webpage-img"
                />
              )}

              {/* 选项 */}
              {open === true && (
                <div className="webpage-list">
                  {biying.map((list) => {
                    return (
                      <div
                        className="webpage-lists"
                        key={list.name}
                        onClick={() => {
                          setWebpage(list.name);
                          setWebimg(list.img);
                          setWeburl(list.url);
                        }}
                      >
                        <img src={list.img} alt="" className="open-img" />
                        <span>{list.name}</span>
                      </div>
                    );
                  })}
                </div>
              )}

              {/* 修改状态收回选项 */}
              {open === true && (
                <img
                  src={require("./img/close.png")}
                  alt=""
                  className="webpage-img"
                />
              )}
            </div>
            {/* 搜索框 */}
            <input
              type=""
              className="search-input"
              placeholder="请输入你想搜索的内容"
              value={content}
              onChange={(e) => {
                setContent(e.target.value);
              }}
              onKeyDown={(e) => {
                if (content !== "") {
                  if (e.keyCode === 13) {
                    if (webpage === "百度") {
                      window.open(`${weburl}=${content}`);
                    }
                    if (webpage === "必应") {
                      window.open(`${weburl}=${content}`);
                    }
                    // if (webpage === "视频") {
                    //   window.open(
                    //     `https://www.baidu.com/sf/vsearch?pd=video&tn=vsearch&H123Tmp=nunew7&word=${content}`
                    //   );
                    // }
                    // if (webpage === "图片") {
                    //   window.open(
                    //     `https://image.baidu.com/search/index?tn=baiduimage&ct=201326592&cl=2&lm=-1&ie=utf-8&fm=hao123&H123Tmp=nunew7&word=${content}`
                    //   );
                    // }
                    // if (webpage === "贴吧") {
                    //   window.open(
                    //     `https://tieba.baidu.com/f?ie=utf-8&sc=hao123&H123Tmp=nunew7&kw=${content}`
                    //   );
                    // }
                    // if (webpage === "知道") {
                    //   window.open(
                    //     `https://zhidao.baidu.com/search?tn=ikaslist&ct=17&ie=utf-8&sc=hao123&rn=20&H123Tmp=nunew7&word=${content}`
                    //   );
                    // }
                    // if (webpage === "新闻") {
                    //   window.open(
                    //     `https://www.baidu.com/s?tn=news&word=${content}`
                    //   );
                    // }
                    // if (webpage === "地图") {
                    //   window.open(
                    //     `https://map.baidu.com/search/${content}/@13540459,3646780,13z?querytype=s&wd=${content}=289&pn=0&device_ratio=1&da_src=shareurl`
                    //   );
                    // }
                    // if (webpage === "更多") {
                    //   window.open(`https://www.baidu.com/more/`);
                    // }
                  }
                }
              }}
            />
            <div
              className="baidu-once"
              onClick={() => {
                if (content !== "") {
                  if (webpage === "百度") {
                    window.open(`${weburl}=${content}`);
                  }
                  if (webpage === "必应") {
                    window.open(`${weburl}=${content}`);
                  }
                  // if (webpage === "视频") {
                  //   window.open(
                  //     `https://www.baidu.com/sf/vsearch?pd=video&tn=vsearch&H123Tmp=nunew7&word=${content}`
                  //   );
                  // }
                  // if (webpage === "图片") {
                  //   window.open(
                  //     `https://image.baidu.com/search/index?tn=baiduimage&ct=201326592&cl=2&lm=-1&ie=utf-8&fm=hao123&H123Tmp=nunew7&word=${content}`
                  //   );
                  // }
                  // if (webpage === "贴吧") {
                  //   window.open(
                  //     `https://tieba.baidu.com/f?ie=utf-8&sc=hao123&H123Tmp=nunew7&kw=${content}`
                  //   );
                  // }
                  // if (webpage === "知道") {
                  //   window.open(
                  //     `https://zhidao.baidu.com/search?tn=ikaslist&ct=17&ie=utf-8&sc=hao123&rn=20&H123Tmp=nunew7&word=${content}`
                  //   );
                  // }
                  // if (webpage === "新闻") {
                  //   window.open(
                  //     `https://www.baidu.com/s?tn=news&word=${content}`
                  //   );
                  // }
                  // if (webpage === "地图") {
                  //   window.open(
                  //     `https://map.baidu.com/search/${content}/@13540459,3646780,13z?querytype=s&wd=${content}=289&pn=0&device_ratio=1&da_src=shareurl`
                  //   );
                  // }
                  // if (webpage === "更多") {
                  //   window.open(`https://www.baidu.com/more/`);
                  // }
                }
              }}
            >
              <span>百度一下</span>
            </div>
          </div>
          {/* 新闻 */}
          <ul>
            {newtitle !== [] && (
              <>
                {newtitle.map((item) => {
                  return (
                    <li key={item.uniquekey}>
                      <span
                        onClick={() => {
                          window.open(item.url);
                        }}
                      >
                        {item.title}
                      </span>
                    </li>
                  );
                })}
              </>
            )}

            {/* 展开新闻列表 */}
            {newslist === false && (
              <img
                src={require("./img/webpage.png")}
                alt=""
                className="center-news-img"
                onClick={() => {
                  setNewslist(true);
                }}
              />
            )}
          </ul>
          {/* 展开的新闻列表 */}
          {newslist === true && (
            <div className="center-allnews">
              <img
                src={require("./img/close.png")}
                alt=""
                className="center-news-imgs"
                onClick={() => {
                  setNewslist(false);
                }}
              />
              {newlist !== [] && (
                <>
                  {newlist.map((todo) => {
                    return (
                      <li key={todo.uniquekey}>
                        <span
                          onClick={() => {
                            window.open(todo.url);
                          }}
                        >
                          {todo.title}
                        </span>
                      </li>
                    );
                  })}
                </>
              )}
            </div>
          )}
        </div>

        {/* 右侧新闻页面 */}
        <div
          className="right-news"
          onMouseEnter={() => {
            setEnter(true);
          }}
          onMouseLeave={() => {
            setEnter(false);
          }}
        >
          {huanlists !== [] && (
            <>
              {huanlists.slice(huan - 1, huan).map((huans) => {
                return (
                  <span key={huans.uniquekey}>
                    <span
                      onClick={() => {
                        window.open(huans.url);
                      }}
                    >
                      {huans.title}
                    </span>
                  </span>
                );
              })}
            </>
          )}

          {enter === true && (
            <img
              src={require("./img/huan.png")}
              alt=""
              className="right-huan"
              onClick={() => {
                setHuan(huan + 1);
                if (huan === len) {
                  setHuan(1);
                }
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
